import React from 'react';
import styled from 'styled-components';

const Card = ({children}) => {
    return <StyledCard className='card'>{children}</StyledCard>;
};

const StyledCard = styled.div`
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: ${({ theme }) => theme.cardShadow};
    background: ${({ theme }) => theme.cardBg};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${({ theme }) => theme.cardShadowHover};
    }
`;

export default Card;
